import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { none, ApplyScreen } from './applyScreen';

interface ApplyState {
    viewModel: ApplyScreen.ViewModel
}

const initialState: ApplyState = {
    viewModel: none()
}

export const applySlice = createSlice({
    name: 'apply',
    initialState,
    reducers: {
        setViewModel: (state, action: PayloadAction<ApplyScreen.ViewModel>) => {
            // eslint-disable-next-line no-console
            console.log('ApplyState: setViewModel')
            state.viewModel = action.payload
        }
    }
})

export const { setViewModel } = applySlice.actions

export default applySlice.reducer